/*
 * Password Messages
 *
 * This contains all the text for the Password component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  minLength: {
    id: 'app.components.Password.minLength',
    defaultMessage: 'At least {min} characters',
  },
  texts: {
    id: 'app.components.Password.texts',
    defaultMessage: 'Worst|Bad|Weak|Good|Strong',
  },
  current: {
    id: 'app.components.Password.current',
    defaultMessage: 'Current password',
  },
  password: {
    id: 'app.components.Password.password',
    defaultMessage: 'Password',
  },
  new: {
    id: 'app.components.Password.new',
    defaultMessage: 'New password',
  },
  retype: {
    id: 'app.components.Password.retype',
    defaultMessage: 'Retype the password',
  },
  noMatch: {
    id: 'app.components.Password.noMatch',
    defaultMessage: 'The passwords do not match',
  },
  weakPassword: {
    id: 'app.components.Password.weakPassword',
    defaultMessage: 'The password isn\'t strong enough',
  },
  weakPasswordFull: {
    id: 'app.components.Password.weakPasswordFull',
    defaultMessage: `<p>The password isn't strong enough. Make it stronger with the following tips and try again:</p><ul>
    <li>Don't use a password that you used before</li>
    <li>Don't use repeating (aaaa) or sequential (abcd) characters</li>
    <li>Don't use your own name, username or email address</li>
    <li>Don't use frequently used or context-specific words like "Social Schools", "Welcome" and "Password"</li></ul>`,
  },
});
